import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useConfirmAccount, usePath } from 'lib/core/hooks'
import { CustomerStyles } from 'lib/shared'
import { Alert, Button, EmptyContainer, Spinner } from 'lib/ui'

export const ConfirmAccount = () => {
  const path = usePath()
  const { push } = useHistory()
  const { loading, failure, success } = useConfirmAccount()

  return (
    <CustomerStyles.PublicLayout>
      <CustomerStyles.Title>
        <FormattedMessage
          id='customer.account.confirm.title'
        />
      </CustomerStyles.Title>

      {loading && (
        <EmptyContainer>
          <Spinner />
        </EmptyContainer>
      )}

      {!loading && success && (
        <Alert type='success'>
          <FormattedMessage
            id='customer.account.confirm.success'
          />
        </Alert>
      )}

      {!loading && failure && (
        <Alert type='danger'>
          <FormattedMessage
            id='customer.account.confirm.failure'
          />
        </Alert>
      )}

      {!loading && success && (
        <>
          <br />
          <div>
            <Button type='button' onClick={() => push(path.login)}>
              <FormattedMessage
                id='action.login'
              />
            </Button>
          </div>
        </>
      )}
    </CustomerStyles.PublicLayout>
  )
}
